// Centralized Spanish labels and constants used across the UI.

export const APP_NAME = "TU TIENDA MANO AMIGA";
export const APP_TAGLINE = "Archivo de clientes";
export const APP_LOGO =
  "https://customer-assets.emergentagent.com/job_doc-manager-81/artifacts/uuihzgp5_logo-tinenda.png";

export const PHONE_OPERATOR_LABELS = {
  "": "—",
  ninguno: "Sin servicio",
  verizon: "Verizon",
  att: "AT&T",
  cricket: "Cricket",
  t_mobile: "T-Mobile",
  sin_pin: "Sin Pin",
  otro: "Otro",
};

export const PHONE_OPERATOR_OPTIONS = [
  "ninguno",
  "verizon",
  "att",
  "cricket",
  "t_mobile",
  "sin_pin",
  "otro",
];

export const TX_TYPE_LABELS = {
  cambio_cheque: "Cambio de cheque",
  envio: "Envío de dinero",
  pago_telefono: "Pago de teléfono",
  recarga: "Recarga",
  otro: "Otro",
};

export const TX_TYPE_OPTIONS = [
  "cambio_cheque",
  "envio",
  "pago_telefono",
  "recarga",
  "otro",
];

export const TX_TYPE_COLORS = {
  cambio_cheque: { bg: "#7C3AED", fg: "#ffffff" },
  envio: { bg: "#0EA5E9", fg: "#ffffff" },
  pago_telefono: { bg: "#F59E0B", fg: "#1F2937" },
  recarga: { bg: "#16A34A", fg: "#ffffff" },
  otro: { bg: "#64748B", fg: "#ffffff" },
};

export const COMMON_COUNTRIES = [
  "República Dominicana",
  "Estados Unidos",
  "México",
  "Puerto Rico",
  "Cuba",
  "Haití",
  "Colombia",
  "Venezuela",
  "Ecuador",
  "Perú",
  "Honduras",
  "El Salvador",
  "Guatemala",
  "Nicaragua",
  "Costa Rica",
  "Panamá",
  "Bolivia",
  "Argentina",
  "Chile",
  "Uruguay",
  "Paraguay",
  "Brasil",
  "España",
  "Otro",
];

export const COUNTRY_FLAGS = {
  "República Dominicana": "🇩🇴",
  "Estados Unidos": "🇺🇸",
  "México": "🇲🇽",
  "Puerto Rico": "🇵🇷",
  "Cuba": "🇨🇺",
  "Haití": "🇭🇹",
  "Colombia": "🇨🇴",
  "Venezuela": "🇻🇪",
  "Ecuador": "🇪🇨",
  "Perú": "🇵🇪",
  "Honduras": "🇭🇳",
  "El Salvador": "🇸🇻",
  "Guatemala": "🇬🇹",
  "Nicaragua": "🇳🇮",
  "Costa Rica": "🇨🇷",
  "Panamá": "🇵🇦",
  "Bolivia": "🇧🇴",
  "Argentina": "🇦🇷",
  "Chile": "🇨🇱",
  "Uruguay": "🇺🇾",
  "Paraguay": "🇵🇾",
  "Brasil": "🇧🇷",
  "España": "🇪🇸",
};

export function formatCurrency(n) {
  const num = Number(n || 0);
  return num.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("es-DO", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch (e) {
    return iso;
  }
}

export function todayInputValue() {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}

export function isoFromInputDate(s) {
  if (!s) return null;
  // s is "YYYY-MM-DD"
  return new Date(`${s}T12:00:00Z`).toISOString();
}

export function inputDateFromIso(iso) {
  if (!iso) return todayInputValue();
  try {
    const d = new Date(iso);
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${mm}-${dd}`;
  } catch (e) {
    return todayInputValue();
  }
}

// Days until a given day-of-month (1..31), from today (local time)
export function daysUntilDay(day) {
  if (!day || day < 1 || day > 31) return null;
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  let target = new Date(now.getFullYear(), now.getMonth(), day);
  if (target < today) {
    target = new Date(now.getFullYear(), now.getMonth() + 1, day);
  }
  const ms = target - today;
  return Math.round(ms / 86400000);
}

// Build a wa.me URL with prefilled text
export function whatsappUrl(phone, message) {
  const clean = (phone || "").replace(/\D/g, "");
  if (!clean) return null;
  const text = encodeURIComponent(message || "");
  return `https://wa.me/${clean}${text ? `?text=${text}` : ""}`;
}

export function smsUrl(phone, message) {
  const clean = (phone || "").replace(/\D/g, "");
  if (!clean) return null;
  const text = encodeURIComponent(message || "");
  return `sms:${clean}${text ? `?&body=${text}` : ""}`;
}
